import { render, staticRenderFns } from "./PreSessionBoxTest.vue?vue&type=template&id=25364a4d&scoped=true&"
import script from "./PreSessionBoxTest.vue?vue&type=script&lang=js&"
export * from "./PreSessionBoxTest.vue?vue&type=script&lang=js&"
import style0 from "./PreSessionBoxTest.vue?vue&type=style&index=0&id=25364a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25364a4d",
  null
  
)

export default component.exports